import React from 'react'
import { FormattedMessage } from 'react-intl'
import { makeStyles } from 'tss-react/mui'
import { Typography } from '@mui/material'

import ShoppingAiBanner from '@src/routes/ShoppingAi/ShoppingAiBanner'

const useStyles = makeStyles()((theme) => ({
  notFindingText: {
    fontWeight: theme.typography.fontWeightBold,
  },
}))

const ProductSearchShoppingAiBanner = () => {
  const { classes } = useStyles()
  return (
    <ShoppingAiBanner
      alertMessage={
        <>
          <Typography className={classes.notFindingText}>
            <FormattedMessage
              id="AI_ASSISTANT_NOT_FINDING_WHAT_YOU_ARE_LOOKING_FOR"
              defaultMessage="Not finding what you are looking for?"
            />
          </Typography>
          <Typography>
            <FormattedMessage
              id="LET_PRODUCT_ASSISTANT_HELP"
              defaultMessage="Let the Product Assistant help you discover the right solution."
            />
          </Typography>
        </>
      }
      gaSection={'no search results'}
    />
  )
}

export default ProductSearchShoppingAiBanner
